var _rect, _circle, _circle2, _rect2, _path, _path2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.6415,
    y: 79.9153,
    width: 137.617,
    height: 80.668,
    rx: 19,
    transform: "rotate(-8.82262 45.6415 79.9153)",
    fill: "#909090",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 75.1666,
    r: 26.5,
    fill: "#F6B40A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 75.1666,
    r: 17.5,
    stroke: "#020202",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 76.6666,
    width: 150,
    height: 88,
    rx: 19,
    fill: "#E4E4E4",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 11.6666C207.543 23.9438 217.223 33.6236 229.5 38.1666C217.223 42.7096 207.543 52.3894 203 64.6666C198.457 52.3894 188.777 42.7096 176.5 38.1666C188.777 33.6236 198.457 23.9438 203 11.6666Z",
    fill: "#3BD59E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 186.667C32.9001 193.153 38.0139 198.267 44.5 200.667C38.0139 203.067 32.9001 208.181 30.5 214.667C28.0999 208.181 22.9861 203.067 16.5 200.667C22.9861 198.267 28.0999 193.153 30.5 186.667Z",
    fill: "#0C5EFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 103.667,
    width: 75,
    height: 35,
    rx: 9,
    fill: "#909090",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletImageIcon);
export default __webpack_public_path__ + "static/media/wallet-image-icon.1f3c610507f9c46cb6a490eb8b024bcf.svg";
export { ForwardRef as ReactComponent };